module.exports = __webpack_public_path__ + "img/aiMee-logo.f9acb315.png";